import { IsNullable } from '@graftcode/protocol'

import { TYPE_USAGE } from '../../../const/graftModelPayload.const'
import { TYPE_USAGE_NODE_KIND } from '../../../const/typeUsageNodeKind.const'
import { UnifiedGraftModelTypeKey } from '../../../const/unifiedGraftModelTypeKeys.const'
import { getUnifiedGraftModelType } from '../../getUnifiedGraftModelType'
import { getTypeUsagePayloadShapeKind } from '../../type-usage/shape.type-usage'

import type { NodeLike } from './types'

export const TYPE_NODE_KINDS = new Set([
  UnifiedGraftModelTypeKey.TYPE_USAGE_VOID,
  UnifiedGraftModelTypeKey.TYPE_USAGE_PRIMITIVE,
  UnifiedGraftModelTypeKey.TYPE_USAGE_GENERIC_ALIAS,
  UnifiedGraftModelTypeKey.TYPE_USAGE_ARRAY,
  UnifiedGraftModelTypeKey.TYPE_USAGE_GENERIC,
])

export function getEffectiveTypeUsageKind(node: NodeLike): string | null {
  const shapeKind = getTypeUsagePayloadShapeKind(node.payload)

  if (shapeKind === TYPE_USAGE_NODE_KIND.TYPE_USAGE_GENERIC_ALIAS) {
    return UnifiedGraftModelTypeKey.TYPE_USAGE_GENERIC_ALIAS
  }

  const declared = getUnifiedGraftModelType(node)
  if (TYPE_NODE_KINDS.has(declared)) {
    return declared
  }

  return shapeKind
}

export function isNullable(p: unknown[]): boolean {
  return p[0] === IsNullable.TRUE || p[0] === String(IsNullable.TRUE)
}

export function nullable(p: unknown[]): string {
  return isNullable(p) ? '?' : ''
}

export function hasPayload(x: unknown): x is NodeLike {
  return !!x && typeof x === 'object' && Array.isArray((x as NodeLike).payload)
}

export function resolveNode(input: NodeLike): NodeLike | null {
  const p = input.payload
  if (p.length === 0) return null
  const kind = getUnifiedGraftModelType(input)
  const inner = p[TYPE_USAGE.NODE]
  const isWrapper = kind === UnifiedGraftModelTypeKey.TYPE_USAGE || (p.length === 1 && hasPayload(inner))
  if (isWrapper && hasPayload(inner)) return inner
  if (getEffectiveTypeUsageKind(input)) return input
  return null
}
